import { useParams, useNavigate } from 'react-router-dom';
import BreadcrumbCRM from '../crm/BreadcrumbCRM';
import ErrorMessages from '../common/ErrorMessages';
import EstadoSelect from '../common/EstadoSelect';
import { useForm } from "react-hook-form";
import { nuevaNota, editarNota, getNota } from '../../services/CRMService';
import { getClientes} from '../../services/ClientesService';
import { Form, Row, Col, Button } from "react-bootstrap";
import { useEffect, useState } from 'react';

function NotasForm() {

    const params = useParams();
    const navigate = useNavigate();
    const {id, nota_id} = params;
    const [errores, setErrores] = useState([]);
    const [clientes, setClientes] = useState([])
    const { register, handleSubmit, formState: { errors }, reset} = useForm({
        defaultValues : {
            fecha : "",
            descripcion : "",
            cliente_id : id,
            estado : "A"
        }
    });

    useEffect(() => {
        const iniciarEdicion = async () => {
            let resp = await getNota(nota_id);
            if (resp.error) {
                setErrores([resp.message]);
            } else {
                reset(resp.data);
            }
        }
        if (nota_id) {
            iniciarEdicion();
        }
    }, [nota_id, reset])

    useEffect(() => {
        getClientes()
            .then((resp) => {
                if (resp.error) {
                    setErrores(resp.message);
                } else {
                    setClientes(resp.data);
                }
            });
    }, [])

    function beforeSubmit() {
        setErrores([]);
    }

    const onSubmit = async (data) => {
        setErrores([]);
        let resp;
        if (nota_id) {
            resp = await editarNota(nota_id, data);
        } else {
            resp = await nuevaNota(data);
        }
        if (resp.error) {
            setErrores(resp.messages);
            window.scrollTo(0,0);
        } else {
            alert(nota_id ? "Nota editada satisfactoriamente" : "Nota guardada satisfactoriamente");
            volver();
        }
    }

    function volver() {
        navigate("/crm/notas/" + id);
    }


    return ( <>
        {
            !nota_id ? <div>
                <BreadcrumbCRM active="Notas de Cliente - Nueva"/>
            </div> : <div>
                <BreadcrumbCRM active="Notas de Cliente - Edición"/>
            </div>
        }
        <ErrorMessages mensajes={errores}/>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">Fecha</Form.Label>
                <Col xs="5" sm="3" md="4">
                    <Form.Control 
                        type="date" 
                        id="fecha" 
                        {...register("fecha", {
                            required: true
                        })}
                        placeholder="Fecha"
                    />
                </Col>
                {
                    errors.fecha?.type === 'required' && 
                    <Col className="validacion error">
                        <p role="alert">La Fecha es requerida.</p>
                    </Col>
                }
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">Descripción</Form.Label>
                <Col sm="8">
                    <Form.Control 
                        as="textarea"
                        rows={2}
                        overflow = "none"
                        id="descripcion" 
                        {...register("descripcion", {
                            required: true
                        })}
                    />
                </Col>
                {
                    errors.descripcion?.type === 'required' && 
                    <Col className="validacion error">
                        <p role="alert">La Descripción es requerida.</p>
                    </Col>
                }
            </Form.Group>
            
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">Cliente</Form.Label>
                <Col sm="8">
                    <Form.Select
                        id="cliente_id"
                        value={id}
                        name="cliente_id"
                        {...register("cliente_id", {required: true})}
                        disabled
                    >
                        <option value="">Seleccione un Cliente</option>
                        {clientes.map((c) =><option 
                            key={c.cliente_id} 
                            value={c.cliente_id}
                        >
                            {c.nombre_razon_social}
                        </option>)}
                    </Form.Select>
                </Col>
                {
                    errors.cliente_id?.type === "required" && 
                    <Col className="validacion error">
                        <p role="alert">El id de cliente es requerido</p>
                    </Col>
                }
                {
                    errors.cliente?.type === "required" && 
                    <Col className="validacion error">
                        <p role="alert">El cliente es requerido</p>
                    </Col>
                }
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Estado
                </Form.Label>
                <Col md="4">
                    <EstadoSelect register={register} name="estado"/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mb-3'>
                <Col>
                    <Button 
                        variant='primary' 
                        onClick={beforeSubmit} 
                        type='submit'
                    >
                        Guardar
                    </Button>
                    <Button variant='secondary' onClick={volver}>Cancelar</Button>
                </Col>
            </Form.Group>
        </Form>

    </>)
}

export default NotasForm